import * as React from "react";
const SvgListIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m0,90v-20h20v20H0Zm30,0v-20h70v20H30ZM0,60v-20h20v20H0Zm30,0v-20h70v20H30ZM0,30V10h20v20H0Zm30,0V10h70v20H30Z" }));
export default SvgListIcon;
